/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VehiclesIndexRouteImport } from './routes/vehicles.index'
import { Route as TransferIndexRouteImport } from './routes/transfer.index'
import { Route as VehiclesVehicle_idRouteImport } from './routes/vehicles.$vehicle_id'
import { Route as LogoutCallbackRouteImport } from './routes/logout.callback'
import { Route as LoginCallbackRouteImport } from './routes/login.callback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesIndexRoute = VehiclesIndexRouteImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransferIndexRoute = TransferIndexRouteImport.update({
  id: '/transfer/',
  path: '/transfer/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesVehicle_idRoute = VehiclesVehicle_idRouteImport.update({
  id: '/vehicles/$vehicle_id',
  path: '/vehicles/$vehicle_id',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutCallbackRoute = LogoutCallbackRouteImport.update({
  id: '/logout/callback',
  path: '/logout/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login/callback': typeof LoginCallbackRoute
  '/logout/callback': typeof LogoutCallbackRoute
  '/vehicles/$vehicle_id': typeof VehiclesVehicle_idRoute
  '/transfer/': typeof TransferIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login/callback': typeof LoginCallbackRoute
  '/logout/callback': typeof LogoutCallbackRoute
  '/vehicles/$vehicle_id': typeof VehiclesVehicle_idRoute
  '/transfer': typeof TransferIndexRoute
  '/vehicles': typeof VehiclesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login/callback': typeof LoginCallbackRoute
  '/logout/callback': typeof LogoutCallbackRoute
  '/vehicles/$vehicle_id': typeof VehiclesVehicle_idRoute
  '/transfer/': typeof TransferIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login/callback'
    | '/logout/callback'
    | '/vehicles/$vehicle_id'
    | '/transfer/'
    | '/vehicles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login/callback'
    | '/logout/callback'
    | '/vehicles/$vehicle_id'
    | '/transfer'
    | '/vehicles'
  id:
    | '__root__'
    | '/'
    | '/login/callback'
    | '/logout/callback'
    | '/vehicles/$vehicle_id'
    | '/transfer/'
    | '/vehicles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
  LogoutCallbackRoute: typeof LogoutCallbackRoute
  VehiclesVehicle_idRoute: typeof VehiclesVehicle_idRoute
  TransferIndexRoute: typeof TransferIndexRoute
  VehiclesIndexRoute: typeof VehiclesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/': {
      id: '/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof VehiclesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transfer/': {
      id: '/transfer/'
      path: '/transfer'
      fullPath: '/transfer/'
      preLoaderRoute: typeof TransferIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/$vehicle_id': {
      id: '/vehicles/$vehicle_id'
      path: '/vehicles/$vehicle_id'
      fullPath: '/vehicles/$vehicle_id'
      preLoaderRoute: typeof VehiclesVehicle_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout/callback': {
      id: '/logout/callback'
      path: '/logout/callback'
      fullPath: '/logout/callback'
      preLoaderRoute: typeof LogoutCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginCallbackRoute: LoginCallbackRoute,
  LogoutCallbackRoute: LogoutCallbackRoute,
  VehiclesVehicle_idRoute: VehiclesVehicle_idRoute,
  TransferIndexRoute: TransferIndexRoute,
  VehiclesIndexRoute: VehiclesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
